"use client";

import { ReactNode } from "react";
import EditableText from "@/app/(components)/generics/EditableText/EditableText";
import { UStyles } from "@/app/utils/UStyles";
import { Limits } from "@/app/vars/Limits";
import styles from "./CallTitle.module.css";

type Props = {
  name: string;
  onSave: (name: string) => void;
  large?: boolean;
  showEditBtn?: boolean;
  beforeIcon?: ReactNode;
  disabled?: boolean;
};

export default function CallTitle(props: Props) {
  const { name, onSave, large = false, showEditBtn = false, beforeIcon, disabled = false } = props;

  if (disabled) {
    return (
      <div className={UStyles.classNames(styles.root, large ? styles.large : "")}>
        {beforeIcon && <span className={styles.icon}>{beforeIcon}</span>}
        <span className={styles.name}>{name}</span>
      </div>
    );
  }

  return (
    <div
      className={UStyles.classNames(
        styles.root,
        large ? styles.large : "",
        showEditBtn ? styles.showEditBtn : "",
      )}
    >
      {beforeIcon && <span className={styles.icon}>{beforeIcon}</span>}
      <EditableText
        value={name}
        maxLength={Limits.MAX_CALL_TITLE}
        onSave={onSave}
        alwaysShowEdit={showEditBtn}
        textClassName={styles.name}
        inputClassName={styles.input}
        className={styles.editableText}
        fitContent={true}
      />
    </div>
  );
}
